import { createSlice } from "@reduxjs/toolkit";
export const httpSlice = createSlice({
  name: "http",
  initialState: {
    error: null,
    ok: null,
    loader: null,
    page: null,
    isOpenDevTools: false,
    devSent: false
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload.loader
      state.page = action.payload.page
      state.error = null
      state.ok = null
    },
    setOk: (state, action) => {
      state.ok = true
      state.error = null
      state.loader = false
      state.page = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.ok = false
      state.loader = false
      state.page = action.payload.page
    },
    setDevtools: (state, action) => {
      state.isOpenDevTools = action.payload
    },
    setDevSent: (state, action) => {
      state.devSent = true
    }
  },
});
